import { Col, Row, Spin } from "antd-v5";
import ACComment from "components/ACComment";
import { useGlobalUserListContext } from "contexts/GlobalUserListContext";
import _ from "lodash";
import React, {
  forwardRef,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
// @ts-expect-error - Could not find a declaration file for module 'react-triggerable-effect'.
import useTriggerableEffect from "react-triggerable-effect";
import AssetsAPI from "restAPI/AssetAPI";
import { CommentResponse } from "types/comment";

import ACCommentEditor, {
  ACCommentEditorProps,
  OnSumbitProps,
} from "ac-components/ac-comment-editor/ACCommentEditor";

export default forwardRef(function AssetCommentSection(
  { assetID }: { assetID: number },
  ref,
) {
  const [comments, setComments] = useState<CommentResponse[]>();
  const [loading, setLoading] = useState(false);
  // const [users, setUsers] = useState([]);
  const { getAllUsersList } = useGlobalUserListContext();

  const userList = useMemo(getAllUsersList, [getAllUsersList]);

  const refresh = useTriggerableEffect(() => {
    setLoading(true);
    const { promise, cancel } = AssetsAPI.getComments(assetID);
    promise
      .then((comments) => {
        setComments(comments.content);
      })
      .finally(() => {
        setLoading(false);
      });
    return cancel;
  }, [assetID]);

  // useEffect(() => {
  //   const { promise, cancel } = UserAPI.getAll();
  //   promise.then((data) => setUsers(data));
  //   return cancel;
  // }, []);

  useImperativeHandle(ref, () => ({ refresh: refresh }), [refresh]);

  const onSend: ACCommentEditorProps["onSubmit"] = async ({
    htmlText: comment,
    markdownText,
    mentionUserIds,
  }) => {
    if (comment) {
      const payload = {
        note: comment,
        userIds: mentionUserIds,
        markdownText,
      };
      let API = AssetsAPI.postComments;
      await API(assetID, payload).promise;
      refresh();
    }
  };

  const onCommentUpdate = async (
    commentId: number,
    { htmlText: comment, markdownText, mentionUserIds }: OnSumbitProps,
  ) => {
    if (comment) {
      const payload = {
        note: comment,
        userIds: mentionUserIds,
        markdownText,
        commentId,
      };
      let API = AssetsAPI.updateComments;
      await API(assetID, payload).promise;
      refresh();
    }
  };

  const renderList = (list: CommentResponse[] | undefined) => {
    return (
      <Spin spinning={loading}>
        <Row>
          <Col span={24}>
            <ACCommentEditor onSubmit={onSend} users={userList} />
          </Col>
          {_.isEmpty(list) ? (
            <Col span={24}>
              <div className="text-center p-l">No comments</div>
            </Col>
          ) : (
            <Col span={24}>
              <ACComment
                commentList={list}
                onCommentSubmit={onCommentUpdate}
                users={userList}
              />
            </Col>
          )}
        </Row>
      </Spin>
    );
  };

  return <>{renderList(comments)}</>;
});
